/* unplugin-vue-components disabled */import { render } from "./SideModalNewsButton.vue?vue&type=template&id=a25f816c&scoped=true"
import script from "./SideModalNewsButton.vue?vue&type=script&lang=js"
export * from "./SideModalNewsButton.vue?vue&type=script&lang=js"

import "./SideModalNewsButton.vue?vue&type=style&index=0&id=a25f816c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25f816c"]])

export default __exports__